import TextField from "@material-ui/core/TextField";
import type { TextFieldProps } from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});

export default function InputOutlined(props: TextFieldProps) {
  const classes = useStyles();
  return <TextField className={classes.root} variant="outlined" {...props} />;
}
